<template lang="pug">
  .post-heading(v-if="heading || subHeading")
    h3.is-size-4-desktop.is-size-5-tablet.is-size-6-mobile(v-if="heading") {{ heading }}
    h4.is-size-6-desktop.is-size-7-touch.uppercase.is-primary(v-if="subHeading") {{ subHeading }}
</template>

<script>
export default {
  name: "Heading",
  props: {
    heading: {
      type: String
    },
    subHeading: {
      type: String
    }
  }
};
</script>

<style lang="sass" scoped>
.post-heading
  margin-bottom: .5rem
  .is-primary
    color: var(--color-primary)
  h3
    margin-bottom: 0
    color: inherit
  h4
    margin-bottom: 0
    font-weight: 450
    letter-spacing: 0
</style>
